module.exports = __webpack_public_path__ + "static/media/project-reference-interface.2e520ab6.png";